import { watchAddedNodes } from '@utilities/dom';
import { Warn } from '@utilities/logging';
import { appendStylesheet } from '@utilities/scripts';

export class StylesheetLoader {
  /**
   * StylesheetLoader constructor
   */
  constructor() {
    watchAddedNodes('.d3-stylesheet', this.process.bind(this));
  }

  async process(target: HTMLElement) {
    const href = target.dataset.href;

    if (!href) return;

    const check = href.split('?').at(0);
    if (document.head.querySelector(`style[data-href*="${check}"],link[href*="${check}"]`)) return;

    try {
      await appendStylesheet(href);
    } catch (e) {
      Warn(`Failed to load stylesheet ${href}`, e);
    }
  }

  static readonly instance = new StylesheetLoader();
}

const AssetsIncluderInstance = StylesheetLoader.instance;
export default AssetsIncluderInstance;
